import EventComponent from '../components/EventComponent';
import { PlannerEcsMultiSystem } from './System';
import { CustomComponentIds } from '@inter-ikea-kvadrat/kvadrat';
const WALL_COUNT = 4;
export class WallVisibilitySystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'WallVisibilitySystem', [
            EventComponent.id,
            CustomComponentIds.ROOM_COMPONENT_ID
        ]);
        this.viewer = this.coreApi.ipexViewer;
        this.wallVertices = {};
        this.normals = [];
        this.wallSegmentsCenterPoint = [];
        this.leftWall = true;
        this.rightWall = true;
        this.frontWall = true;
        this.backWall = true;
    }
    onAdd(entity, newComponent) {
        switch (newComponent.typeId) {
            case EventComponent.id:
                if (newComponent.event === 'update') {
                    this.update();
                }
                break;
            case CustomComponentIds.ROOM_COMPONENT_ID:
                this.init();
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        switch (newComponent.typeId) {
            case EventComponent.id:
                if (newComponent.event === 'update') {
                    this.update();
                }
                break;
            case CustomComponentIds.ROOM_COMPONENT_ID:
                this.init();
        }
    }
    onRemove() { }
    init() {
        const roomSize = this.coreApi.kvadratRoom?.getSize();
        if (!roomSize)
            return;
        const width = roomSize?.X / 1000;
        const height = roomSize?.Y / 1000;
        const depth = roomSize?.Z / 1000;
        this.wallVertices = [
            { x: -width / 2, y: 0, z: depth, w: height },
            { x: -width / 2, y: 0, z: 0, w: height },
            { x: width / 2, y: 0, z: 0, w: height },
            { x: width / 2, y: 0, z: depth, w: height }
        ];
        for (let i = 0; i < WALL_COUNT; i++) {
            const coord1 = this.wallVertices[i];
            const coord2 = this.wallVertices[(i + 1) % this.wallVertices.length];
            // Calculate the wall normal from the two points that corresponds to its start and end
            const dx = coord2?.x - coord1?.x;
            const dz = coord2?.z - coord1?.z;
            const normal = { x: -dz, y: 0, z: dx };
            // Normalize it
            const normalLength = Math.sqrt(Math.pow(normal.x, 2.0) + Math.pow(normal.z, 2.0));
            normal.x /= normalLength;
            normal.z /= normalLength;
            this.normals.push(normal);
            // Calculate the wall segments center point, this is where we'll put the walls frame, offset by the wall segment normal
            const center = { x: (coord1.x + coord2.x) * 0.5, y: 0, z: (coord1.z + coord2.z) * 0.5 };
            this.wallSegmentsCenterPoint.push(center);
        }
    }
    update() {
        const cameraPosition = this.viewer.get_active_camera()?.position;
        if (!cameraPosition)
            return;
        for (let i = 0; i < WALL_COUNT; i++) {
            const wallCenterPoint = this.wallSegmentsCenterPoint[i];
            const normal = this.normals[i];
            if (!normal || !wallCenterPoint) {
                return;
            }
            // Calculate if the camera is behind the wall the frame belongs to, by  taking any point on the wall (in this case the planes center)
            // and checking the sign of the dot product between the walls normal and the vector from the cameras position to the point on the wall
            const toPlane = {
                x: wallCenterPoint.x - cameraPosition.x,
                y: wallCenterPoint.y,
                z: wallCenterPoint.z - cameraPosition.z
            };
            const dotProduct = normal.x * toPlane.x + normal.y * toPlane.y + normal.z * toPlane.z;
            const visible = dotProduct < 0;
            // Compare the normals from Viewer to Core so we can link correct visibility to each wall
            if (this.normals[i].x === 1 && this.normals[i].y === 0 && this.normals[i].z === 0) {
                this.leftWall = visible;
            }
            if (this.normals[i].x === 0 && this.normals[i].y === 0 && this.normals[i].z === 1) {
                this.frontWall = visible;
            }
            if (this.normals[i].x === -1 && this.normals[i].y === 0 && this.normals[i].z === 0) {
                this.rightWall = visible;
            }
            if (this.normals[i].x === 0 && this.normals[i].y === 0 && this.normals[i].z === -1) {
                this.backWall = visible;
            }
        }
        const wallVisibility = {
            left: this.leftWall,
            front: this.frontWall,
            right: this.rightWall,
            back: this.backWall
        };
        this.coreApi.scene?.setWallVisibility(wallVisibility);
    }
}
//# sourceMappingURL=WallVisibilitySystem.js.map